<!-- ── Footer ─────────────────────────────────────────── -->
<footer class="footer" id="contact">
  <div class="container">
    <div class="footer-grid">
      <div>
        <div class="footer-logo">
          <div class="footer-logo-icon">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L2 7v10l10 5 10-5V7L12 2zm0 2.236L20 8.5v7L12 19.764 4 15.5v-7L12 4.236z"/>
            </svg>
          </div>
          <div class="footer-logo-text">DGRAD</div>
        </div>
        <p class="footer-desc">
          Direction Générale des Recettes Administratives, Judiciaires,
          Domaniales et de Participations — portail officiel LOGIRAD.
        </p>
        <div class="footer-socials">
          <a href="#" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg></a>
          <a href="#" aria-label="Twitter"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg></a>
          <a href="#" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg></a>
          <a href="#" aria-label="LinkedIn"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg></a>
        </div>
      </div>
      <div class="footer-col">
        <h4>Liens rapides</h4>
        <ul>
          <li><a routerLink="/">Accueil</a></li>
          <li><a routerLink="/galerie">Galerie</a></li>
          <li><a routerLink="/documentation">Documentation</a></li>
          <li><a routerLink="/contact">Contact</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <h4>Contact</h4>
        <div class="footer-contact-item">
          <span class="icon">📍</span>
          <span>Boulevard Colonel Tshatshi, Kinshasa-Gombe, RDC</span>
        </div>
        <div class="footer-contact-item">
          <span class="icon">📞</span>
          <span>+243 (21) 000 0000</span>
        </div>
        <div class="footer-contact-item">
          <span class="icon">✉️</span>
          <span>info&#64;dgrad.cd</span>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© Tous droits réservés — DGRAD</span>
      <div class="footer-bottom-links">
        <a href="#">Confidentialité</a>
        <a href="#">Conditions d'utilisation</a>
      </div>
    </div>
  </div>
</footer>